import { useMemo } from "react";
import { validator } from "@/utils/validator";
import { MAX_CHARACTER_INPUT_VALIDATION, MAX_MANAGEMENT_NUMBER_VALIDATION, MAX_TEXT_INPUT_VALIDATION } from "@/constants/common";
import { TFilter } from "@/api/services/main/case/dtos/create-case.dto";

export const useCaseSchema = () => {
  const caseSchema = useMemo(() => {
    return validator.object().shape({
      name: validator.string().trim().label("案件名").max(MAX_CHARACTER_INPUT_VALIDATION).required(),
      managementNumber: validator.string().trim().label("案件管理番号").max(MAX_MANAGEMENT_NUMBER_VALIDATION).required(),
      personInChargeId: validator.number().isSelection().label("案件担当者").required(),
      memo: validator.string().trim().label("案件メモ").max(MAX_TEXT_INPUT_VALIDATION).notRequired(),
      talentFilter: validator.mixed<TFilter>().required(),
    });
  }, []);

  return { caseSchema };
};
